const spaces = [
  {
    title: 'Hot Desks',
    description: 'Natural light, open views, and a distraction-free setup for focused work.',
    image: 'https://pub-0a73c6fd83b94478ade039aa11d5ad47.r2.dev/desks/IMG_20260226_160625580_HDR.jpg',
    features: ['Focus Desk with Outdoor View', 'Personal lockers', 'High-speed internet', 'Coffee & tea included'],
    accent: '#1F473E'
  },
  {
    title: 'Dedicated Desks',
    description: 'Your own personal desk in a shared office environment.',
    image: 'https://pub-0a73c6fd83b94478ade039aa11d5ad47.r2.dev/desks/IMG_20260226_160853041_HDR.jpg',
    features: ['Reserved desk', 'Personal lockers', 'High-speed internet','Coffee & tea included'],
    accent: '#49685E'
  },
  {
    title: 'Meeting Rooms',
    description: 'Professional meeting space for discussions, presentations, and team collaboration.',
    image: 'https://pub-0a73c6fd83b94478ade039aa11d5ad47.r2.dev/desks/IMG_20260226_161029874_HDR.jpg',
    features: ['6-Seater Meeting Room', 'Smart TV / Display Screen','High-speed internet','Video Conferencing Support', 'Whiteboard & Markers'],
    accent: '#88998D'
  }
];

export function Spaces() {
  return (
    <section id="spaces" className="py-16 md:py-20 bg-[#F1ECDC]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl text-[#1F473E] mb-4">Choose Your Workspace</h2>
          <p className="text-xl text-[#49685E] max-w-2xl mx-auto">
            From flexible hot desks to private offices, find the perfect space for your needs
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          {spaces.map((space, index) => (
            <div key={index} className="bg-white rounded-lg overflow-hidden border border-[#D8D7C8] hover:border-[#49685E] hover:shadow-xl transition-all group">
              <div className="h-48 overflow-hidden relative">
                <img 
                  src={space.image} 
                  alt={space.title}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-6">
                <h3 className="text-2xl text-[#1F473E] mb-2">{space.title}</h3>
                <p className="text-[#49685E] mb-4">{space.description}</p>
                <ul className="space-y-2">
                  {space.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start text-[#49685E]">
                      <span className="mr-2" style={{ color: space.accent }}>✓</span>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}